import { DiceMultipleIcon } from './DiceMultipleIcon';

/**
 * author: Michael Richins
 * id 8C9D5084-1B34-4AB9-BE23-E44B03AE85E5
 * name dice-multiple
 * version: 1.9.32
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/dice-multiple.svg
 * tags
 * - Gaming / RPG 
 */
export const DieMultipleIcon = DiceMultipleIcon;
export default DieMultipleIcon